import { Route, Routes } from "react-router-dom";
import Main from "./pages/Main";
import NotFoundRedirect from "./NotFoundRedirect";

function AppRoute() {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="*" element={<NotFoundRedirect />} />
    </Routes>
  );
}

export default AppRoute;
